import type { LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * The way to the other input, where one of two is the primary one.
 *
 * A quiet text button rather than a tab or a second primary control, which is the whole point of the
 * asymmetry it serves: dropping files is the act, and pasting is the way out for when the thing is in
 * a window rather than a file. Anything with a border or a fill would read as a peer and put the
 * choice back in front of the person — which is what a segmented control did here before.
 *
 * Shared by `/add` and a project's own starter card so the two cannot drift into different shapes for
 * the same idea.
 */
export function InputModeSwitch({
  icon: Icon,
  label,
  onClick,
  className,
}: {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'inline-flex items-center gap-1.5 text-[11px] font-medium text-ink-muted',
        'hover:text-orange-600 dark:hover:text-orange-400 transition-colors',
        className,
      )}
    >
      <Icon size={12} />
      {label}
    </button>
  );
}
